import React, { createContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './Home.module.scss';

// Import components
import PageWrapper from 'components/Layout/PageWrapper/PageWrapper';
import indexPost from 'actions/post/index';
import indexPage from 'actions/page/index';
import indexCategory from 'actions/category/index';
import Grid from './Grid/Grid';
import YouTooText from './YouTooText/YouTooText';

// Import action

// Create and export context
type HomeContextType = {
  activeFilters: number[];
  setActiveFilters: React.Dispatch<React.SetStateAction<number[]>>;
};
export const HomeContext = createContext({} as HomeContextType);

export type FilterOptions =
  | 'eenmalig contact'
  | 'serie sessies'
  | 'fysiek contact'
  | 'voorbereiding'
  | 'nazorg';

export default function Home() {
  const [activeFilters, setActiveFilters] = useState<FilterOptions[]>([]);

  const dispatch = useDispatch();

  // Add stuff to store
  useEffect(() => {
    dispatch(indexPost());
    dispatch(indexPage());
    dispatch(indexCategory());
  }, []);

  // get stuff from store
  const data: any[] = useSelector((state) =>
    state.post.entities.allIds.map((postId) => state.post.entities.byId[postId])
  );
  // console.log(data);

  return (
    <HomeContext.Provider value={{ activeFilters, setActiveFilters, data }}>
      <PageWrapper filterMenu>
        <YouTooText />
        <Grid />
      </PageWrapper>
    </HomeContext.Provider>
  );
}
